import React from 'react'
import Anime from 'react-anime'
import styled from 'styled-components'

const IconWrapper = styled.div`
  margin-right: 15px;
  display: inline-block;
  opacity: 1;
  color: ${props => props.theme.color};
  transform: translateY(-2px);
`

const Section = styled.section`
  margin: 50px 0;
`

const Feature = ({icon, title, color, children}) => (
  <Section>
    <h3>
      <IconWrapper>{icon}</IconWrapper>
      <span>{title}</span>
    </h3>
    <p>{children}</p>
  </Section>
)

export default Feature



// WEBPACK FOOTER //
// ./src/components/feature.js